<template>
    <div class="pdf-side-bar">
        <div
            class="jump-page-warpper"
            v-if="pageCount > 1"
        >
            <i
                class="iconfont icon-lastpage side-bar-icon rotate"
                :class="{ 'is-disabled': currentPage === 1 }"
                @click="jumpPage(1)"
                title="跳转至首页"
            ></i>
            <div class="jump-page-divider"></div>
            <i
                class="iconfont icon-lastpage side-bar-icon"
                :class="{ 'is-disabled': currentPage === pageCount }"
                @click="jumpPage(pageCount)"
                title="跳转至末页"
            ></i>
        </div>

        <slot name="sidebar-append"></slot>
    </div>
</template>
a
<script>
export default {
    name: 'PdfSideBar',
    inject: ['scrollToPage'],
    props: {
        pageCount: Number,
        currentPage: Number,
    },
    methods: {
        jumpPage (pageNo) {
            this.scrollToPage?.(pageNo);
        }
    }
}
</script>

<style lang="less" scoped>
.pdf-side-bar {
    width: 50px;
    z-index: 5;
    right: 180px;
    position: fixed;
    bottom: 64px;
    height: 120px;

    .jump-page-warpper {
        width: 40px;
        border-radius: 40px;
        background: #fff;
        padding: 6px 0;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);

        .jump-page-divider {
            width: 100%;
            height: 2px;
            background: #f7f8f8;
        }
    }

    .side-bar-icon {
        color: #4c596e;
        display: block;
        width: 40px;
        font-size: 24px;
        height: 48px;
        border-radius: 40px;

        padding: 8px;
        box-sizing: border-box;
        cursor: pointer;
        line-height: 32px;
        &:hover {
            color: #2489f2;
        }

        &.rotate {
            transform: rotate(180deg);
        }

        &.is-disabled {
            color: #c1c6cd !important;
            cursor: no-drop;
        }
    }
}
</style>